<template>
  <div>
    <tabs-component
      :tabs-data="tabsData"
      @get-selected-tab="setSelectedTab"
    />
    <div class="page-content">
      <users-view v-if="selectedTab === 'users'" />
      <modules-view v-if="selectedTab === 'modules'" />
    </div>
  </div>
</template>

<script>
import UsersView from './UsersView';
import ModulesView from './ModulesView';
import TabsComponent from '@/modules/DataManagement/views/tableBuilder/components/TabsComponent.vue';

export default {
  name: 'UserSecurityView',
  components: {
    TabsComponent,
    UsersView,
    ModulesView,
  },
  data() {
    return {
      selectedTab: 'users',
      tabsData: [
        {id: 1, label: 'Users', value: 'users', icon: 'users'},
        {id: 2, label: 'Modules', value: 'modules', icon: 'layer-group'},
      ],
    };
  },
  methods: {
    setSelectedTab(tab) {
      this.selectedTab = tab;
    },
  },
};
</script>

<style lang="scss">
.page-content {
  padding: 20px 10px;
}
.nav-content {
  background: white;
}
</style>